import { Ptag } from "../../../components/fonts";
import React from "react";
import { colors } from "../../../theme";

const GradeSimpleDetail = ({ title, text, children, style }) => {
  return (
    <section style={{ maxWidth: "110ch", marginBottom: "30px", ...style }}>
      <Ptag fontWeight="bold" fontSize="16px" color={colors.primaryColor}>
        {title}
        {text ? (
          <Ptag fontSize="14px" marginTop="8px">
            {text}
          </Ptag>
        ) : (
          children
        )}
      </Ptag>
    </section>
  );
};

export default GradeSimpleDetail;
